export const initialStartHours = "18:00";
export const initialMinutes = "100";
export const initialGrades = ["中学生", "中学生", "中学生"];

export const lessonStartHours: string[] = ["14:00", "16:00", "18:00", "20:00"];
export const lessonMinutes = ["50", "80", "100"];
export const lessonGrades = ["なし", "小学生", "中学生", "高校生"];
